<template>
  <div class="single-view solutions">
    <view-background
      ref="background"
      :background="background"/>

    <hero-block
      :title="title"
      :subtitle="subtitle"
      :animate-in="entering"
      :animation-direction="animationDirection" />

    <content-wrapper>
      <two-columns-content>
        <template slot="header">
          <header class="block--header">
            <h2>Ricercati per vocazione</h2>
          </header>
        </template>

        <template slot="right-column">
          <h3>Intro</h3>
          <h4>L'attività di ricerca è il motore che nel tempo conduce all'eccellenza qualitativa. POLOLAB investe senza sosta in tecnologia e formazione.</h4>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/ricerca/attrezzatura.jpg')">
              <img :src="require('@/assets/ricerca/attrezzatura.jpg')" alt="Partner Rossetto">
            </picture>
          </figure>

          <div class="anchor" data-anchor="Stabilizzazione colore"></div>
          <h3>Stabilizzazione del colore dei vini rossi</h3>
          <h4>Per mezzo di spettrometri di massa ad alta risoluzione UPLC-HRML Orbitrap identifichiamo la presenza nei vini di qualsiasi sostanza organica.</h4>
          <p>
            Nel nostro laboratorio, tali metodiche vengono utilizzate nei seguenti campi di interesse:
            <ul>
              <li>
                <p>mettere a punto tecniche atte a stabilizzare il colore del vino rosso, approfondendo i meccanismi di degradazione di diversi composti responsabili delle precipitazioni di sostanze coloranti (per esempio il comportamento della quercetina e la sua degradazione in kaempferol e tamarixetin).</p>
              </li>
              <li>
                <p>definire protocolli di vinificazione atti a stabilizzare il colore impedendo le precipitazioni di sostanza colorante sia in serbatoio che in bottiglia.</p>
              </li>
            </ul>
          </p>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/ricerca/macchina-professionale.jpg')">
              <img :src="require('@/assets/ricerca/macchina-professionale.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Biologia molecolare"></span>

          <h3>Biologia molecolare</h3>
          <h4>L'estrazione automatica del DNA e la successiva analisi (PCR-REAL TIME o PCR Endpoint) permettono di identificare in modo univoco un organismo.</h4>

          <accordion :elements="accordionDataProdotti" />

          <rossetto-video :video-id="'Xgtx6vHVeZg'" />

          <span class="bottom-anchor"></span>

          <span class="anchor" data-anchor="Abbattimento pesticidi"></span>

          <h3>Abbattimento dei pesticidi e loro metaboliti.</h3>
          <h4>Siamo in grado di individuare oltre 300 differenti molecole di pesticidi per ciascuna sessione, utilizzando la spettrometria di massa a triplo quadrupolo LC-MS e la gascromatografia-spettrometria di massa GC-MS, con altissima precisione e risultati in 5 giorni.</h4>
          <h4>Abbiamo messo a punto un protocollo per consentire l'abbattimento dall'80 al 100% di ben 120 principi attivi identificati presenti nei pesticidi</h4>

          <figure class="figure-padded">
            <picture>
              <source media="(min-width: 700px)" :srcset="require('@/assets/ricerca/macchina-laboratorio.jpg')">
              <img :src="require('@/assets/ricerca/abbattimento-pesticidi.jpg')" alt="Quality Rossetto">
            </picture>
          </figure>

          <span class="bottom-anchor"></span>
          <br />
          <br />
          <br />
          <span class="anchor" data-anchor="Cessioni del collante"></span>

          <h3>Cessioni del collante</h3>
          <h4>Cessioni del collante da parte dei tappi micro agglomerati. Abbiamo individuato nuove molecole cedute dai tappi in sughero agglomerato e micro agglomerato, che producono nei vini alterazioni organolettiche rilevanti</h4>

          <p>
            L'alta tecnologia a nostra disposizione ci consente di dare "nome, cognome e parternità" a numerosi sgradevoli sentori, di cui fino ad oggi si potevano solo ipotizzare le cause, senza però identificarle con certezza. POLOLAB dispone di una vasta tipologia strumentale per conseguire rapidamente risultati di elevata precisione, quali:
            <ul>
              <li><p><strong>UPLC-MS/MS</strong> triplo quadrupolo</p></li>
              <li><p><strong>GC-MS/MS</strong> con triplo quadrupolo</p></li>
              <li><p><strong>UHPLC/DAD/TOF</strong></p></li>
              <li><p><strong>GC-MS/MS</strong> (trappola ionica). Vengono impiegati per analisi routinarie di pesticidi, plasticizzanti, vitamine, cloroanisoli, micotossine altri analiti di interesse vitivinicolo.</p></li>
              <li><p><strong>UHPLC-HRMS</strong> (Orbitrap Technologies). Impiegato per ricerca analitica generica indeterminata e conforme ad elevata risoluzione ed accuratezza.</p></li>
              <li><p><strong>Rotor-Gene Q</strong> Impiegato per amplificazione del DNA in metodiche Endpoint e Realtime.</p></li>
              <li><p><strong>Micromanipolatore</strong> Utile per la dissezione delle spore e conseguente coniugazione per l'ottenimento di ibridi.</p></li>
              <li><p><strong>ICP-OES</strong> Spettrometro ad emissione ottica di plasma per l'analisi dei metalli</p></li>
              <li><p><strong>Microscopio elettronico</strong></p></li>
            </ul>
          </p>
          <span class="bottom-anchor"></span>
        </template>
      </two-columns-content>
    </content-wrapper>

    <global-footer />
  </div>
</template>

<script>
import guards from './SingleView/guards'
import garbage from './SingleView/garbage'
import backgrounds from './SingleView/backgrounds'
import { mapMutations } from 'vuex'
import HeroBlock from '../components/HeroBlock'
import ContentWrapper from '../components/ContentWrapper'
import GlobalFooter from '../components/GlobalFooter'
import ViewBackground from '../components/ViewBackground'
import Accordion from '../components/Accordion'
import VisualCounter from '../components/VisualCounter'
import TwoColumnsContent from '../components/ContentWrapper/TwoColumnsContent'
import RossettoButton from '../components/RossettoButton'
import Slider from '../components/Slider'
import RossettoVideo from '../components/RossettoVideo'

export default {
  mixins: [ guards, garbage, backgrounds ],
  components: {
    HeroBlock,
    ContentWrapper,
    GlobalFooter,
    ViewBackground,
    TwoColumnsContent,
    RossettoButton,
    Slider,
    Accordion,
    RossettoVideo,
    VisualCounter
  },
  data: () => ({
    title: 'Ricerca e sviluppo',
    subtitle: 'L\'innovazione: punto di contatto di know how avanzato e tecnologia all\'avanguardia',
    slides: require('./Company/slider-loghi.json'),
    bgName: 'company',
    bgOptions: {
      wave: {
        horizontalSpread: 2,
        verticalSpread: 1
      }
    },
    accordionDataProdotti: require('../components/Accordion/ricerca-e-sviluppo.json')
  }),
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ])
  }
}
</script>
